import { Table } from "antd";
import React from "react";
import ToggleSwitch from "../../../CommonComponents/ToggleSwitch/ToggleSwitch";

import "./stylesTransactionRoutes.css";
import { render } from "@testing-library/react";
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (_, text) => {
      return (
        <span>
          {Number(text.minAmount).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}
          -
          {Number(text.maxAmount).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}
        </span>
      );
    },
    sorter: (a, b) => a.amount - b.amount,
  },
  {
    title: "Primary processor",
    dataIndex: "primaryProcessor",
    key: "primaryProcessor",
    sorter: (a, b) => a.primaryProcessor.length - b.primaryProcessor.length,
  },
  {
    title: "Period",
    dataIndex: "period",
    key: "period",
    sorter: (a, b) => a.period.length - b.period.length,
  },
  {
    title: "Max. #",
    dataIndex: "max",
    key: "max",
    sorter: (a, b) => a.max - b.max,
  },
  {
    title: "Max. $",
    dataIndex: "maxDollar",
    key: "maxDollar",
    sorter: (a, b) => a.maxDollar - b.maxDollar,
    render: (text) => {
      return (
        <span>
          {Number(text).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}
        </span>
      );
    },
  },
  {
    title: "Activity",
    dataIndex: "activity",
    key: "activity",
    render: (text) => {
      return (
        <ToggleSwitch
          status={text === "Active"}
          eventCode="event_code"
          updateEventCode={() => {}}
          onlyUpdate={true}
          data={{ event_code: "event_code", is_active: text === "Active" }}
        />
      );
    },
  },
];

function TransactionRoutes({ data }) {
  return (
    <div className="transaction-routes-container">
      <div className="transaction-routes-table">
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="key"
          scroll={{ x: 1200 }}
        />
      </div>
    </div>
  );
}

export default TransactionRoutes;
